import { createSelector } from "reselect";
import get from "lodash/get";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import { isInProgress } from "App/apiMiddleware";
import actionTypes from "./actionTypes";
import reduce from "lodash/reduce";
import forEach from "lodash/forEach";
export const getMethodList = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].methods`, []), (state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].objects`, []), (methods, objects) => {
    const attributesKeyToNameMap = reduce(objects, (acc, obj) => {
        forEach(obj.Attributes, attr => {
            const { Key, Name } = attr;
            acc[Key] = Name;
        });
        return acc;
    }, {});
    const methodToObjectsMap = reduce(objects, (acc, obj) => {
        forEach(obj.AvailableMethods, methodId => {
            var _a, _b;
            const RequiredMethodAttributesFromTable = (_b = (_a = obj.RequiredMethodAttributes) === null || _a === void 0 ? void 0 : _a[methodId]) === null || _b === void 0 ? void 0 : _b.map(({ Item1, Item2 }) => ({
                Item1,
                Item2: Item2 === null || Item2 === void 0 ? void 0 : Item2.map(key => {
                    var _a;
                    return ({
                        Key: key,
                        Name: (_a = attributesKeyToNameMap[key]) !== null && _a !== void 0 ? _a : ""
                    });
                })
            }));
            const newItem = { ...obj, RequiredMethodAttributesFromTable };
            if (!acc[methodId]) {
                acc[methodId] = [newItem];
            }
            else {
                acc[methodId].push(newItem);
            }
        });
        return acc;
    }, {});
    return methods.map(method => {
        var _a;
        return ({
            ...method,
            Objects: (_a = methodToObjectsMap[method.Id]) !== null && _a !== void 0 ? _a : []
        });
    });
});
export const getInProgress = (state) => isInProgress(state, actionTypes.GET_METHODS) || isInProgress(state, actionTypes.GET_OBJECTS);
